import type { WeeklyMemberMetric, WeeklyMetric } from "../lib/types";

interface WeeklyMetricCardProps {
  metric: WeeklyMetric & Partial<Pick<WeeklyMemberMetric, "slug">> & { displayName: string };
  household?: boolean;
}

export function WeeklyMetricCard({ metric, household = false }: WeeklyMetricCardProps) {
  const percentage = metric.completionRate === null ? null : Math.round(metric.completionRate * 100);
  return (
    <article className="weekly-person" data-member={household ? "household" : metric.slug}>
      <header>
        <span className="member-color" aria-hidden="true" />
        <h2>{metric.displayName}</h2>
        <strong>{metric.points} <small>點</small></strong>
      </header>
      {percentage === null ? (
        <p className="no-rate">本週尚無到期任務</p>
      ) : (
        <div className="rate-row">
          <progress
            className="rate-track"
            aria-label={`${metric.displayName}準時率`}
            aria-valuenow={percentage}
            max={100}
            value={percentage}
          />
          <b>{percentage}%</b>
        </div>
      )}
      <dl className="metric-grid">
        <div><dt>到期</dt><dd>{metric.assignedDue}</dd></div>
        <div><dt>完成</dt><dd>{metric.completed}</dd></div>
        <div><dt>準時</dt><dd>{metric.onTime}</dd></div>
        <div className={metric.overdueOpen > 0 ? "metric-alert" : ""}><dt>逾期未完</dt><dd>{metric.overdueOpen}</dd></div>
      </dl>
    </article>
  );
}
